import { syncChannelEpochKey, type EpochSyncResult } from '@clinikchat/shared';
import api from './api';

/**
 * Give a channel the creator just made its first key, through the epoch flow.
 *
 * The server auto-creates epoch 1 in DISTRIBUTING state. The creator (its owner)
 * finishes that epoch by sealing ONE fresh key to every current member, so the key
 * held in the epoch key ring IS epoch 1's key and every member can decrypt what is
 * sent under it. Call after the initial members have been added.
 *
 * Deliberately writes no legacy flat key: a flat key that is not the epoch's key
 * produces messages with no keyEpoch that other members cannot decrypt.
 *
 * Never throws; inspect `outcome` ('ready' means the ring now holds the key). A
 * non-ready result recovers on its own when the creator opens the channel, since
 * useChannelEpochKey completes a DISTRIBUTING epoch for an admin.
 */
export function bootstrapNewChannelKey(
  channelId: string,
  secretKey: string,
): Promise<EpochSyncResult> {
  return syncChannelEpochKey({ api, secretKey }, channelId, { bootstrapFirstEpoch: true });
}
